import { EMPTY_VALUE } from '@src/core/config';

export const arcFormatLatitudeOrderCell = (value: string | number | null | undefined): string => {
  const n = Number(value);
  if (value == null || value === '' || Number.isNaN(n)) return 'N/A';
  return (n.toFixed(4) || EMPTY_VALUE) + '° N';
};

export const arcFormatLongitudeOrderCell = (value: string | number | null | undefined): string => {
  const n = Number(value);
  if (value == null || value === '' || Number.isNaN(n)) return 'N/A';
  return (n.toFixed(4) || EMPTY_VALUE) + '° E';
};
